module.exports = "/packs/images/changing_places_logo_green~3aa72c930cd6ad0ffa5653f888ea1f7a.png";